module.exports = __webpack_public_path__ + "315b309d3ac938a024d11737cc781b38.svg";